/** The title menu (docs/spec/07 §2) and the scrolling message under it. Pure. */

import type { Route } from '../scene';
import type { MenuItem } from '../kit/menuModel';

export interface TitleItem extends MenuItem {
  readonly route: Route;
  /** Replace the title rather than open on top of it (the Construction Kit is a world of its own). */
  readonly replace?: boolean;
}

export const TITLE_ITEMS: readonly TitleItem[] = [
  { id: 'classic', label: 'PLAY CLASSIC', route: { to: 'setup', set: 'classic' } },
  { id: 'deep', label: 'THE DEEP', route: { to: 'setup', set: 'deep' } },
  { id: 'expedition', label: 'EXPEDITION', route: { to: 'expedition' } },
  { id: 'daily', label: 'DAILY DIG', route: { to: 'daily' } },
  { id: 'practice', label: 'PRACTICE', route: { to: 'practice' } },
  { id: 'kit', label: 'CONSTRUCTION KIT', route: { to: 'kit' }, replace: true },
  { id: 'hiscores', label: 'HIGH SCORES', route: { to: 'hiscores' } },
  { id: 'options', label: 'OPTIONS', route: { to: 'options' } },
  { id: 'help', label: 'HOW TO PLAY', route: { to: 'help' } },
  { id: 'credits', label: 'CREDITS', route: { to: 'credits' } },
];

/** Idle this long on the title and the attract demo plays (04 §7). */
export const IDLE_MS = 20_000;

/** The sine scroller's text. The original game is only ever named on the credits screen. */
export function marqueeText(game: string, hero: string, topScore: string): string {
  return [
    `WELCOME TO ${game}`,
    `DIG FOR DIAMONDS, DODGE THE BOULDERS AND RUN FOR THE EXIT`,
    `HIGH SCORE ${topScore}`,
    `HOLD FIRE WITH A DIRECTION TO GRAB WITHOUT MOVING`,
    `DROP A BOULDER ON A BUTTERFLY FOR A SHOWER OF DIAMONDS`,
    `FIREFLIES HUG THE WALLS - SO SHOULD ${hero}`,
    `A NEW DAILY DIG EVERY DAY`,
    `HOW DEEP CAN YOU GO ON AN EXPEDITION?`,
    `BUILD AND SHARE YOUR OWN CAVES IN THE CONSTRUCTION KIT`,
    `IN TRIBUTE TO PETER LIEPA AND CHRIS GRAY'S 1984 CLASSIC`,
    `ALL GRAPHICS, SOUND AND MUSIC ARE GENERATED FROM CODE`,
    '',
  ].join('   ◆   ');
}
